import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { utils, writeFile } from "xlsx";
import { formatoFecha } from "@/util/varios";

import { Dimmer } from "../../spinner";

import {
  validaSoloNumero,
  // validaNumeroTelefono, validaEmail
} from "../../../util/varios";
// import axios from 'axios';
// import moment from 'moment';
import CatalogoLiquidador from "../../../catalogos/catalogoLiquidador";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import moment from "moment";
import axios from "axios";

export const ImpSectorActiEconomica2 = (props) => {
  /*  variables de estados */
  const fechaActual = new Date().toISOString().split("T")[0];
  const anioActual = new Date().getFullYear();

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  // const [contar2, setContar2] = useState(0);
  const [tecla, setTecla] = useState();
  const [anio, setAnio] = useState();
  const [tituContri, setTituContri] = useState("");
  const [visibleF, setVisibleF] = useState("visible");
  const [visibleA, setVisibleA] = useState("collapse");
  const [visibleM, setVisibleM] = useState("hidden");
  const [visibleAnio, setVisibleAnio] = useState("collapse");
  const [visiblePeriodo, setVisiblePeriodo] = useState("collapse");
  const [visibleFI, setVisibleFI] = useState("collapse");
  const radioDeclararon = useRef();
  const radioNoDeclararon = useRef();
  const radioContribuyente = useRef();
  const radioLiquidador = useRef();
  const radioTodos = useRef();
  const radioFecha = useRef();
  const txtFechaIn = useRef();
  const cmbTipCont = useRef("");
  const cmbAnio = useRef("");
  const cmbMes = useRef("");
  const cmbMesDesde = useRef("");
  const cmbMesHasta = useRef("");
  const cmbAnioDesde = useRef("");
  const cmbAnioHasta = useRef("");
  const chkSector = useRef();
  const chkActividad = useRef();
  const cmbTipoDecla = useRef("");
  const txtDiaDesde = useRef();
  const txtAlDia = useRef();
  const chkActivo = useRef();
  const chkInactivo = useRef();
  const chkClausurado = useRef();
  const chkFiscal = useRef();
  const chkNotificado = useRef();
  const chkDepLegal = useRef();
  const chkExonerado = useRef();
  const chkRevCerrado = useRef();
  const txtCodigo = useRef();
  const txtNombre = useRef();
  const anioActu = localStorage.getItem("anioactu");
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: afin + 1 - i });
    }
    setAnio(nanio);
  }, []);

  useEffect(() => {
    /*         if (props.tiporep === 104 && contar1 === 0) {
            cmbAnio.current.value = anio[anio.length - 1].anio;
            cmbAnioDesde.current.value = anio[anio.length - 1].anio;
            cmbAnioHasta.current.value = anio[anio.length - 1].anio;
            setContar1(1);
        } */
  });

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const handleCloseSi = () => {
    setMostrar1(false);
    var reporte = "ListGenxActiv";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "";
    var condicion = "";
    if (radioDeclararon.current.checked) {
      sql = "  ACT.anios = " + cmbAnio.current.value;
    } else {
      sql =
        "  ACT.codigoactividad = '" +
        txtCodigo.current.value +
        "' AND ACT.anios = " +
        cmbAnio.current.value;
    }
    sql4 = "Según la Actividad Económica y el SECTOR";
    sql2 = "";
    condicion = sql;
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        condicion +
        "&TIT_RGO1=" +
        sql2 +
        "&ORDEN=" +
        sql3 +
        "&TIT_ADICIONAL=" +
        sql4,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const handleCloseNo = () => {
    setMostrar1(false);
    var reporte = "ListGenxActiv1";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "";
    var condicion = "";
    if (radioDeclararon.current.checked) {
      sql = "  ACT.anios = " + cmbAnio.current.value;
    } else {
      sql =
        "  ACT.codigoactividad = '" +
        txtCodigo.current.value +
        "' AND ACT.anios = " +
        cmbAnio.current.value;
    }
    sql4 = "Según la Actividad Económica y el SECTOR";
    sql2 = "";
    condicion = sql;
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        condicion +
        "&TIT_RGO1=" +
        sql2 +
        "&ORDEN=" +
        sql3 +
        "&TIT_ADICIONAL=" +
        sql4,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputDiaDesde") {
        txtDiaDesde.current.value = txtDiaDesde.current.value
          .toString()
          .trim()
          .padStart(2, 0);
        if (
          txtDiaDesde.current.value > txtAlDia.current.value &&
          txtDiaDesde.current.value !== "" &&
          txtAlDia.current.value !== ""
        ) {
          setTitulo("Error");
          setMsg(
            "El Rango no es Valido, El Campo Desde el Día es Mayor que el Campo Al Día.",
          );
          setMostrar(true);
        } else {
          if (event.which === 13) {
            txtAlDia.current.focus();
          }
        }
      } else if (event.target.id === "inputDiaHasta") {
        txtAlDia.current.value = txtAlDia.current.value
          .toString()
          .trim()
          .padStart(2, 0);
        if (
          txtDiaDesde.current.value > txtAlDia.current.value &&
          txtDiaDesde.current.value !== "" &&
          txtAlDia.current.value !== ""
        ) {
          setTitulo("Error");
          setMsg(
            "El Rango no es Valido, El Campo Desde el Día es Mayor que el Campo Al Día.",
          );
          setMostrar(true);
        } else {
          if (event.which === 13) {
            cmbTipoDecla.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const imprimirReporte = () => {
    var sigue = true;
    var tiene31 =
      cmbMesHasta.current.value.padStart(2, 0) === "01" ||
      cmbMesHasta.current.value.padStart(2, 0) === "03" ||
      cmbMesHasta.current.value.padStart(2, 0) === "05" ||
      cmbMesHasta.current.value.padStart(2, 0) === "07" ||
      cmbMesHasta.current.value.padStart(2, 0) === "08" ||
      cmbMesHasta.current.value.padStart(2, 0) === "10" ||
      cmbMesHasta.current.value.padStart(2, 0) === "12"
        ? true
        : false;
    var maxdiafeb = parseFloat(cmbAnio.current.value) / 4 === 0 ? 29 : 28;

    if (
      txtDiaDesde.current.value === "" ||
      txtDiaDesde.current.value === "00"
    ) {
      setTitulo("Error");
      setMsg("El día desde no es valido.");
      sigue = false;
      txtDiaDesde.current.focus();
    } else if (
      txtAlDia.current.value === "" ||
      txtAlDia.current.value === "00"
    ) {
      setTitulo("Error");
      setMsg("El día hasta no es valido.");
      sigue = false;
      txtAlDia.current.focus();
    } else if (
      txtDiaDesde.current.value > txtAlDia.current.value &&
      txtDiaDesde.current.value !== "" &&
      txtAlDia.current.value !== ""
    ) {
      setTitulo("Error");
      setMsg(
        "El Rango no es Valido, El Campo Desde el Día es Mayor que el Campo Al Día.",
      );
      sigue = false;
      txtAlDia.current.focus();
    } else if (tiene31 && parseInt(txtAlDia.current.value) > 31) {
      setTitulo("Error");
      setMsg("El Campo Al Día no debe ser mayor a 31.");
      sigue = false;
      txtAlDia.current.focus();
    } else if (
      !tiene31 &&
      cmbMesHasta.current.value.padStart(2, 0) !== "02" &&
      parseInt(txtAlDia.current.value) > 30
    ) {
      setTitulo("Error");
      setMsg("El Campo Al Día no debe ser mayor a 30.");
      sigue = false;
      txtAlDia.current.focus();
    } else if (
      !tiene31 &&
      cmbMesHasta.current.value.padStart(2, 0) === "02" &&
      parseInt(txtAlDia.current.value) > maxdiafeb
    ) {
      setTitulo("Error");
      setMsg("El Campo Al Día no debe ser mayor a " + maxdiafeb + ".");
      sigue = false;
      txtAlDia.current.focus();
    } else if (
      radioContribuyente.current.checked &&
      txtNombre.current.value === ""
    ) {
      setTitulo("Error");
      setMsg("Debe seleccionar el Contribuyente.");
      sigue = false;
      txtCodigo.current.focus();
    } else if (
      radioLiquidador.current.checked &&
      txtNombre.current.value === ""
    ) {
      setTitulo("Error");
      setMsg("Debe seleccionar el Liquidador.");
      sigue = false;
      txtCodigo.current.focus();
    } else if (
      radioFecha.current.checked &&
      txtFechaIn.current.value.trim() === ""
    ) {
      setTitulo("Error");
      setMsg("Por Favor Seleccione la Fecha de Inscripción.");
      sigue = false;
      txtAlDia.current.focus();
    }

    if (sigue) {
      var reporte = "";
      var sql = "";
      var sql2 = "";
      var sql3 = "";
      var sql4 = "";
      var sql5 = "";
      var sql6 = "";
      // var val2;
      // var val3;
      var condicion = "";
      /* var a = chkActivo.current.checked ? "51," : "0,";
            var i = chkInactivo.current.checked ? "52," : "0,";
            var c = chkClausurado.current.checked ? "53," : "0,"
            var f = chkFiscal.current.checked ? "54," : "0,";
            var n = chkNotificado.current.checked ? "55," : "0,";
            var d = chkDepLegal.current.checked ? "56," : "0,";
            var e = chkExonerado.current.checked ? "57," : "0,";
            var r = chkRevCerrado.current.checked ? "58" : "0";
            var status_cade = a + i + c + f + n + d + e + r; */
      if (radioDeclararon.current.checked) {
        if (chkSector.current.checked) {
          reporte = "ListFechDecl";
        } else if (chkActividad.current.checked) {
          reporte = "ListFechDeclxActi";
        } else {
          reporte = "ListFechDecl";
        }
        sql =
          "DJUR.fechadeclaracion Between '" +
          cmbAnioDesde.current.value +
          "-" +
          cmbMesDesde.current.value.trim().padStart(2, 0) +
          "-" +
          txtDiaDesde.current.value +
          "'" +
          " AND '" +
          cmbAnioHasta.current.value +
          "-" +
          cmbMesHasta.current.value.trim().padStart(2, 0) +
          "-" +
          txtAlDia.current.value +
          "'";

        if (cmbTipoDecla.current.value !== "5") {
          sql =
            sql +
            " AND djur.tipo = " +
            cmbTipoDecla.current.value +
            " AND djur.anio = " +
            cmbAnio.current.value;
          if (cmbTipoDecla.current.value !== "1") {
            sql = sql + " AND  djur.nummes = " + cmbMes.current.value;
          }
        }

        sql2 =
          "Período de Declaración: Desde " +
          " " +
          cmbMesDesde.current[cmbMesDesde.current.selectedIndex].text +
          "-" +
          cmbAnioDesde.current.value +
          "  Hasta " +
          " " +
          cmbMesHasta.current[cmbMesHasta.current.selectedIndex].text +
          "-" +
          cmbAnioHasta.current.value;
        sql3 = "";
        /* if (cmbTipCont.current.value === 'TODOS') {
                    sql3 = "COM.STATUS IN (" + status_cade + ")";
                } else {
                    sql3 = "COM.TIPOCONTRIBUYENTE = '" + cmbTipCont.current.value + "'" + " AND COM.STATUS IN (" + status_cade + ")"; 
                } */

        sql4 = "Contribuyentes que Declararon ";
        //sql5 = "CONTRIBUYENTES " + cmbTipCont.current.value;
        sql5 = "CONTRIBUYENTES TODOS";
        if (radioFecha.current.checked) {
          sql6 =
            "COM.fechainscripcion >= '" + txtFechaIn.current.value.trim() + "'";
        } else {
          sql6 = "true";
        }
        //condicion = sql + " AND " + sql3 + " AND " + sql6;
        condicion = sql + " AND " + sql6;

        window.open(
          op.reportes +
            "/actividadeconomica?" +
            "reporte=" +
            reporte +
            "&CONDICION=" +
            condicion +
            "&TIT_RGO1=" +
            sql2 +
            "&TIT_RGO2=" +
            sql5 +
            "&TIT_ADICIONAL=" +
            sql4,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (radioNoDeclararon.current.checked) {
        reporte = "ListFechDeclNO";
        let condicion = `d.fechadeclaracion between '${anioActual}-01-01' and '${fechaActual}' and anio = ${anioActual}`;
        let condicion2 = `${cmbMes.current.value} `;
        let tipo = "";
        switch (cmbTipoDecla.current.value) {
          case "1":
            tipo += " and tipo = 1";
            break;
          case "2":
            tipo += " and tipo = 2";
            break;
          case "3":
            tipo += " and tipo = 3";
            break;
          case "4":
            tipo += " and tipo = 4";
            break;
          case "5":
            tipo += " and tipo in (1,2,3,4)";
            break;
          default:
            break;
        }

        sql2 = `Período de Declaración: ${cmbMes.current[cmbMes.current.selectedIndex].text} / ${anioActual}`;

        if (radioFecha.current.checked) {
          condicion +=
            " and c.fechainscripcion >= '" +
            txtFechaIn.current.value.trim() +
            "'";
        } else {
          condicion += " and true";
        }
        window.open(
          op.reportes +
            "/actividadeconomica?" +
            "reporte=" +
            reporte +
            "&CONDICION=" +
            condicion +
            "&CONDICION2=" +
            condicion2 +
            "&TIT_RGO1=" +
            sql2 +
            "&TIT_RGO2=" +
            sql5 +
            "&TIT_ADICIONAL=" +
            sql4 +
            `&TIPO=${tipo}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (radioContribuyente.current.checked) {
        reporte = "DeclaracionContri";

        sql =
          "dj.idcomercio = " +
          txtCodigo.current.value.trim() +
          " and anio Between " +
          cmbAnioDesde.current.value +
          " and " +
          cmbAnioHasta.current.value +
          " and nummes Between " +
          +cmbMesDesde.current.value +
          " and " +
          cmbMesHasta.current.value +
          " and dj.fechadeclaracion <= '" +
          cmbAnioHasta.current.value +
          "-" +
          cmbMesHasta.current.value.padStart(2, "0") +
          "-" +
          txtAlDia.current.value.padStart(2, "0") +
          "'";

        if (cmbTipoDecla.current.value !== "5") {
          sql =
            sql +
            " AND dj.tipo = " +
            cmbTipoDecla.current.value +
            " AND dj.anio = " +
            cmbAnio.current.value;
          if (cmbTipoDecla.current.value !== "1") {
            sql = sql + " AND  dj.nummes = " + cmbMes.current.value;
          }
        }

        sql2 =
          "Período de Declaración: Desde " +
          " " +
          cmbMesDesde.current[cmbMesDesde.current.selectedIndex].text +
          "-" +
          cmbAnioDesde.current.value +
          "  Hasta " +
          " " +
          cmbMesHasta.current[cmbMesHasta.current.selectedIndex].text +
          "-" +
          cmbAnioHasta.current.value;

        if (radioFecha.current.checked) {
          sql6 =
            "COM.fechainscripcion >= '" + txtFechaIn.current.value.trim() + "'";
        } else {
          sql6 = "true";
        }
        condicion = sql + " AND " + sql6;
        window.open(
          op.reportes +
            "/actividadeconomica?" +
            "reporte=" +
            reporte +
            "&CONDICION=" +
            condicion +
            "&TIT_RGO1=" +
            sql2,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (radioLiquidador.current.checked) {
        reporte = "ListFechDeclGenLiq2";

        sql2 =
          "Período de Declaración: Desde " +
          " " +
          cmbMesDesde.current[cmbMesDesde.current.selectedIndex].text +
          "-" +
          cmbAnioDesde.current.value +
          "  Hasta " +
          " " +
          cmbMesHasta.current[cmbMesHasta.current.selectedIndex].text +
          "-" +
          cmbAnioHasta.current.value;

        var FechaHasta =
          cmbAnioHasta.current.value +
          "-" +
          cmbMesHasta.current.value.trim().padStart(2, 0) +
          "-" +
          txtAlDia.current.value;
        var FechaDesde =
          cmbAnioDesde.current.value +
          "-" +
          cmbMesDesde.current.value.trim().padStart(2, 0) +
          "-" +
          txtDiaDesde.current.value;

        if (FechaDesde === FechaHasta) {
          sql = " DJUR.fechadeclaracion = '" + FechaHasta + "'";
          sql2 =
            "Declaraciones Correspondientes al día " +
            txtAlDia.current.value +
            "/" +
            cmbMesDesde.current.value.trim().padStart(2, 0) +
            "/" +
            cmbAnioHasta.current.value;
        } else {
          sql =
            " DJUR.fechadeclaracion Between '" +
            FechaDesde +
            "' and '" +
            FechaHasta +
            "'";
        }

        if (cmbTipoDecla.current.value !== "5") {
          sql = sql + " AND DJUR.tipo = " + cmbTipoDecla.current.value;
        }

        sql4 = "Contribuyentes que Declararon";

        if (radioFecha.current.checked) {
          sql6 =
            "COM.fechainscripcion >= '" + txtFechaIn.current.value.trim() + "'";
        } else {
          sql6 = "true";
        }

        condicion = sql + " AND " + sql6;
        window.open(
          op.reportes +
            "/actividadeconomica?" +
            "reporte=" +
            reporte +
            "&CONDICION=" +
            condicion +
            "&ID=" +
            txtCodigo.current.value +
            "&TIT_RGO1=" +
            sql2 +
            "&TIT_ADICIONAL=" +
            sql4,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      }
    } else {
      setMostrar(true);
    }
  };

  const imprimirExcel = async () => {
    try {
      setActivate(true)
      let condicion = `d.fechadeclaracion between '${anioActual}-01-01' and '${fechaActual}' and anio = ${anioActual}`;
      let condicion2 = `${cmbMes.current.value} `;
      let tipo = "";
      switch (cmbTipoDecla.current.value) {
        case "1":
          tipo += " and tipo = 1";
          break;
        case "2":
          tipo += " and tipo = 2";
          break;
        case "3":
          tipo += " and tipo = 3";
          break;
        case "4":
          tipo += " and tipo = 4";
          break;
        case "5":
          tipo += " and tipo in (1,2,3,4)";
          break;
        default:
          break;
      }

      const campos = `*`;

      const tabla = `
  (
    select distinct on (idcomercio) *
    from (
      select
  c.idcomercio,
  c.rif,
  c.nombre,
  c.telefono,
  c.direccion,
  to_char(d.fechadeclaracion, 'DD/MM/YYYY') as fechadeclaracion,
  d.anio,
  d.nummes,
  case
    when d.tipo = 3 then (d.mes || ' / ' || d.anio) || ' 1 Quincena'
    when d.tipo = 4 then (d.mes || ' / ' || d.anio) || ' 2 Quincena'
    else d.mes || ' / ' || d.anio
  end as UltimaDeclaración
from comercio c
inner join djurada d on d.idcomercio = c.idcomercio
where ${condicion}
  and c.status = 51
    ) declaraciones
    where nummes <= ${condicion2}
      and idcomercio not in (
        select idcomercio
        from (
          select
            c.idcomercio,
            d.nummes,
            d.tipo
          from comercio c
          inner join djurada d on d.idcomercio = c.idcomercio
          where ${condicion}
            and c.status = 51
        ) d2
        where nummes = ${condicion2} ${tipo}
      )
    order by idcomercio, fechadeclaracion desc, nummes desc
  ) una_fila_por_comercio
`;

      const orden = `idcomercio desc`;
      const endpoint =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(tabla)}&orden=${encodeURIComponent(orden)}`;
      await axios.get(endpoint).then((response) => {
        const { data } = response;
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "SinDeclarar"); // Nombre de la pestaña
        writeFile(
          workbook,
          `ComerciosSinDeclarar-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`, // Nombre del archivo
        );
      });
    } catch (error) {
      console.warn(error);
    } finally{
      setActivate(false)
    }
  };

  const salir = (e) => {
    e.preventDefault();
    /*setContar(1);
        setContar5(1);
        setContar3(1);
        blanquear();*/
    setVisibleF("visible");
    setVisibleA("collapse");
    setVisibleM("hidden");
    setVisibleAnio("visible");
    setVisibleFI("collapse");
    setVisiblePeriodo("visible");
    //props.setShow();
    props.onHideCancela();
  };

  const handleChangeRadioDeclara = (event) => {
    if (radioNoDeclararon.current.checked) {
      setVisiblePeriodo("collapse");
      setVisibleM("visible");
      setVisibleAnio("visible");
    } else {
      setVisiblePeriodo("visible");
    }
    txtCodigo.current.value = "";
    txtNombre.current.value = "";
    setTituContri(event.target.value);
    if (event.target.value === "1" || event.target.value === "2") {
      setVisibleF("visible");
      setVisibleA("collapse");
    } else if (event.target.value === "3" || event.target.value === "4") {
      setVisibleA("visible");
      setVisibleF("collapse");
    }
  };

  const handleChangeRadioFechaInscri = (event) => {
    if (event.target.value === "1") {
      setVisibleFI("collapse");
    } else if (event.target.value === "2") {
      setVisibleFI("visible");
      if (txtFechaIn.current.value.trim() === "") {
        let fecha = anioActu + "-01-01";
        txtFechaIn.current.value = moment.utc(fecha).format("YYYY-MM-DD");
      }
    }
  };

  const handleChangeTipoDeclaracion = (event) => {
    if (radioNoDeclararon.current.checked) {
      setVisibleM("visible");
      setVisibleAnio("visible");
    } else {
      if (event.target.value === "1") {
        setVisibleM("hidden");
        setVisibleAnio("visible");
      } else if (
        event.target.value === "2" ||
        event.target.value === "3" ||
        event.target.value === "4"
      ) {
        setVisibleM("visible");
        setVisibleAnio("visible");
      } else if (event.target.value === "5") {
        setVisibleM("hidden");
        setVisibleAnio("hidden");
      } else {
        setVisibleM("hidden");
        setVisibleAnio("visible");
      }
    }
  };

  const handleCatalogo = () => {
    //e.preventDefault();
    if (radioLiquidador.current.checked) {
      setMostrar2(true);
    } else if (radioContribuyente.current.checked) {
      setMostrar3(true);
    }
  };

  const handleCloseCatalogoLiq = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogoLiq = (login, nombres, idLiq) => {
    setMostrar2(false);
    txtCodigo.current.value = idLiq;
    txtNombre.current.value = nombres.trim();
    btnAcepta.current.focus();
  };

  const handleCloseCatalogoCom = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoCom = (idCome, nombre, codCat) => {
    setMostrar3(false);
    txtCodigo.current.value = idCome;
    txtNombre.current.value = nombre.trim();
    btnAcepta.current.focus();
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtNombre.current.value = "";
    //txtNombreRep.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        seleccionarRegistro(event.target.value);
        //setActivate(true);
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  const seleccionarRegistro = (codigo) => {
    let endpoint = "";
    if (radioContribuyente.current.checked) {
      let campos = "*";
      let nomtab = "comercio";
      let nomid = "idcomercio";
      endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;
    } else {
      let campos = "nombres";
      let nomtab = "usuario";
      let nomid = "idusuario";
      let nomtab2 = "persona";
      let nomid2 = "persona";
      let nomid3 = "cedula";
      endpoint = `${op.conexion}/api/consulta/modeli11?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&nomid3=${nomid3}`;
    }

    setActivate(true);
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            console.log(response.data);
            //  txtLicenciaActu.current.value = response.data.codigopatente;
            txtNombre.current.value = radioContribuyente.current.checked
              ? response.data.nombre
              : response.data.nombres;
            btnAcepta.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("Error");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setContar1(0);
      }}
    >
      <Modal.Header className="azulGradiant">
        {props.titulo1}
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <CatalogoLiquidador
          titulo={titulo}
          mensaje={msg}
          show={mostrar2}
          onHideCancelaCatLiq={handleCloseCatalogoLiq}
          onHideAceptaCatLiq={handleAceptaCatalogoLiq}
        />
        <CatalogoComercio
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatCom={handleCloseCatalogoCom}
          onHideAceptaCatCom={handleAceptaCatalogoCom}
        />
        <div>
          <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
            <legend
              className="float-none w-auto fw-bold"
              style={{ fontSize: "15px" }}
            >
              {props.titulo2}
            </legend>

            <div className="row col-md-12 px-0 mx-auto">
              <div className="row col-md-12 mx-auto">
                <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "13px" }}
                  >
                    Condición del Contribuyente
                  </legend>

                  <div className="col-md-12 row mx-auto d-flex justify-content-between">
                    <div className="form-check col-md-4  mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="radioCondicion"
                        value="1"
                        id="radioSi"
                        defaultChecked={true}
                        ref={radioDeclararon}
                        onChange={handleChangeRadioDeclara}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Declararon
                      </label>
                    </div>
                    <div className="form-check col-md-4  mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="radioCondicion"
                        value="2"
                        id="radioNo"
                        ref={radioNoDeclararon}
                        onChange={handleChangeRadioDeclara}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio3"
                      >
                        No Declararon
                      </label>
                    </div>
                    <div className="form-check col-md-3  mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="chkSector"
                        name="accactividad"
                        ref={chkSector}
                      />
                      <label
                        className="form-check-label"
                        for="flexCheckDefault"
                      >
                        Por Sector
                      </label>
                    </div>
                    <div className="form-check col-md-4  mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="radioCondicion"
                        value="3"
                        id="radioContri"
                        ref={radioContribuyente}
                        onChange={handleChangeRadioDeclara}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Por Contribuyente
                      </label>
                    </div>

                    <div className="form-check col-md-4  mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="radioCondicion"
                        value="4"
                        id="radioLiqui"
                        ref={radioLiquidador}
                        onChange={handleChangeRadioDeclara}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadio2"
                      >
                        Por Liquidador
                      </label>
                    </div>

                    <div className="form-check col-md-3  mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        disabled={true}
                        id="chkActividad"
                        name="accactividad"
                        ref={chkActividad}
                      />
                      <label
                        className="form-check-label"
                        for="flexCheckDefault"
                      >
                        Por Actividad
                      </label>
                    </div>
                    <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
                      <legend
                        className="float-none w-auto fw-bold"
                        style={{ fontSize: "13px" }}
                      >
                        Fecha de Inscripción
                      </legend>
                      <div className="col-md-12 row mx-auto d-flex">
                        <div className="form-check col-md-2 mb-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="radioInscri"
                            value="1"
                            id="radioTodo"
                            defaultChecked={true}
                            ref={radioTodos}
                            onChange={handleChangeRadioFechaInscri}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            Todos
                          </label>
                        </div>
                        <div className="form-check col-md-4 mb-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="radioInscri"
                            value="2"
                            id="radioFechaInscri"
                            ref={radioFecha}
                            onChange={handleChangeRadioFechaInscri}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            Por Fecha de Inscripción
                          </label>
                        </div>
                        <div
                          className="input-group input-group-sm mb-1 col-md-6"
                          style={{ visibility: visibleFI }}
                        >
                          <span
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Fecha de Inscripción:{" "}
                          </span>
                          <input
                            type="date"
                            ref={txtFechaIn}
                            className="form-control text-uppercase"
                            name="fechaincripcion"
                            /*value={values ? values.fechaincripcion ? moment.utc(values.fechaincripcion).format('YYYY-MM-DD') : '' : ''}*/ id="inputFecha"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </fieldset>
              </div>
              <div className="row col-md-12 mx-auto py-2 px-0">
                <fieldset
                  className=" row col-md-7 border-azul rounded mx-auto d-flex justify-content-between"
                  style={{ visibility: visiblePeriodo }}
                >
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "13px" }}
                  >
                    Período de Declaración
                  </legend>

                  <div className="col-md-12 row mx-auto px-0">
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Desde:
                      </span>
                      <select
                        name=""
                        ref={cmbMesDesde}
                        className="form-select form-select-sm"
                      >
                        <option key="0" value="1">
                          ENERO
                        </option>
                        <option key="1" value="2">
                          FEBRERO
                        </option>
                        <option key="2" value="3">
                          MARZO
                        </option>
                        <option key="3" value="4">
                          ABRIL
                        </option>
                        <option key="4" value="5">
                          MAYO
                        </option>
                        <option key="5" value="6">
                          JUNIO
                        </option>
                        <option key="6" value="7">
                          JULIO
                        </option>
                        <option key="7" value="8">
                          AGOSTO
                        </option>
                        <option key="8" value="9">
                          SEPTIEMBRE
                        </option>
                        <option key="9" value="10">
                          OCTUBRE
                        </option>
                        <option key="10" value="11">
                          NOVIEMBRE
                        </option>
                        <option key="11" value="12">
                          DICIEMBRE
                        </option>
                      </select>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Hasta:
                      </span>
                      <select
                        name=""
                        ref={cmbMesHasta}
                        className="form-select form-select-sm"
                        defaultValue={fechaSistema.toString().substring(6, 8)}
                      >
                        <option key="0" value="1">
                          ENERO
                        </option>
                        <option key="1" value="2">
                          FEBRERO
                        </option>
                        <option key="2" value="3">
                          MARZO
                        </option>
                        <option key="3" value="4">
                          ABRIL
                        </option>
                        <option key="4" value="5">
                          MAYO
                        </option>
                        <option key="5" value="6">
                          JUNIO
                        </option>
                        <option key="6" value="7">
                          JULIO
                        </option>
                        <option key="7" value="8">
                          AGOSTO
                        </option>
                        <option key="8" value="9">
                          SEPTIEMBRE
                        </option>
                        <option key="9" value="10">
                          OCTUBRE
                        </option>
                        <option key="10" value="11">
                          NOVIEMBRE
                        </option>
                        <option key="11" value="12">
                          DICIEMBRE
                        </option>
                      </select>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Año Desde:
                      </span>
                      <select
                        name=""
                        ref={cmbAnioDesde}
                        className="form-select form-select-sm"
                      >
                        {anio &&
                          anio.map((a) => (
                            <option key={a.anio} value={a.anio}>
                              {a.anio}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Año Hasta:
                      </span>
                      <select
                        name=""
                        ref={cmbAnioHasta}
                        className="form-select form-select-sm"
                      >
                        {anio &&
                          anio.map((a) => (
                            <option key={a.anio} value={a.anio}>
                              {a.anio}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Desde el Día:
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        ref={txtDiaDesde}
                        maxLength={2}
                        id="inputDiaDesde"
                        defaultValue="01"
                        onKeyUp={handleInputNumChange}
                        onBlur={handleInputNumChange}
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-6">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        al Día:
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        ref={txtAlDia}
                        maxLength={2}
                        id="inputDiaHasta"
                        defaultValue={
                          fechaSistema
                            ? fechaSistema.toString().substring(9, 11)
                            : "01"
                        }
                        onKeyUp={handleInputNumChange}
                        onBlur={handleInputNumChange}
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset className=" row col-md-5 py-3">
                  {/*  <legend className="float-none w-auto fw-bold" style={{ fontSize: '13px' }}>Período de Declración</legend>
                   */}
                  <div className="col-md-6 mx-auto mb-2">
                    <select
                      name=""
                      ref={cmbTipoDecla}
                      defaultValue="5"
                      className="form-select form-select-sm rounded-pill"
                      onChange={handleChangeTipoDeclaracion}
                    >
                      {/* <option key="0" value="0">Estimada</option> */}
                      <option key="1" value="1">
                        Definitiva
                      </option>
                      <option key="2" value="2">
                        Regular
                      </option>
                      <option key="3" value="3">
                        PRIMERA QUINCENA
                      </option>
                      <option key="4" value="4">
                        SEGUNDA QUINCENA
                      </option>
                      <option key="5" value="5">
                        Todas
                      </option>
                    </select>
                  </div>

                  <div
                    className="input-group input-group-sm mb-2 col-md-7"
                    style={{ visibility: visibleAnio && visiblePeriodo }}
                  >
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Año:
                    </span>
                    <select
                      name=""
                      ref={cmbAnio}
                      className="form-select form-select-sm"
                    >
                      {anio &&
                        anio.map((a) => (
                          <option key={a.anio} value={a.anio}>
                            {a.anio}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div
                    className="input-group input-group-sm mb-2 col-md-8"
                    style={{ visibility: visibleM }}
                  >
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Mes:
                    </span>
                    <select
                      name=""
                      ref={cmbMes}
                      className="form-select form-select-sm"
                    >
                      <option key="0" value="1">
                        ENERO
                      </option>
                      <option key="1" value="2">
                        FEBRERO
                      </option>
                      <option key="2" value="3">
                        MARZO
                      </option>
                      <option key="3" value="4">
                        ABRIL
                      </option>
                      <option key="4" value="5">
                        MAYO
                      </option>
                      <option key="5" value="6">
                        JUNIO
                      </option>
                      <option key="6" value="7">
                        JULIO
                      </option>
                      <option key="7" value="8">
                        AGOSTO
                      </option>
                      <option key="8" value="9">
                        SEPTIEMBRE
                      </option>
                      <option key="9" value="10">
                        OCTUBRE
                      </option>
                      <option key="10" value="11">
                        NOVIEMBRE
                      </option>
                      <option key="11" value="12">
                        DICIEMBRE
                      </option>
                    </select>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row col-md-12" style={{ visibility: visibleA }}>
              <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
                <legend
                  className="float-none w-auto fw-bold"
                  style={{ fontSize: "13px" }}
                >
                  {tituContri === "3"
                    ? "Contribuyente"
                    : tituContri === "4"
                      ? "Liquidador"
                      : ""}
                </legend>

                <div className="input-group input-group-sm mb-2 col-md-4 mt-2">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </span>
                  <input
                    type="text"
                    autoComplete="off"
                    ref={txtCodigo}
                    className="form-control form-control-sm"
                    id="inputCodActividad"
                    onKeyUp={validarCodigo}
                    onBlur={validarCodigo}
                  />
                  <button
                    style={{ color: "white" }}
                    onClick={handleCatalogo}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fas fa-search"></i>{" "}
                  </button>
                </div>

                <div className="input-group input-group-sm mb-2 col-md-8 mt-2">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Nombre:
                  </span>
                  <input
                    type="text"
                    disabled={true}
                    ref={txtNombre}
                    className="form-control form-control-sm"
                    id="inputDescripcionActi"
                  />
                </div>
              </fieldset>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {radioNoDeclararon.current && radioNoDeclararon.current.checked && (
          <button
            ref={btnAcepta}
            onClick={() => imprimirExcel()}
            className="btn btn-sm btn-info rounded-pill col-md-2"
          >
            <i className="fas fa-file-pdf"> Excel</i>
          </button>
        )}

        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm btn-primary rounded-pill col-md-2"
        >
          <i className="fas fa-print"> Imprimir</i>
        </button>
        <button
          ref={btnSalir}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fa fa-sign-out"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
